export const BOXES_URL = `${process.env.REACT_APP_BACK_SHEET}/boxes`

export const BOXES_GET_ALL = {
  url: BOXES_URL,
  method: 'GET',
}
